import React from "react";
import PropTypes from "prop-types";
import "../../css/Cards/CardContact.css";
import "../../css/Cards/Card.css";
import Card from "./Card";
import ChevronRight from "../../svg/ICON_chevronRight_Dark.svg";

/**
 * CardContact component for the Home Page
 */
class CardContact extends React.Component {
  static displayName = "CardContact";
  static propTypes = {
    className: PropTypes.string,
    image: PropTypes.object,
    currentPage: PropTypes.object.isRequired,
    stores: PropTypes.object.isRequired,
  };
  static defaultProps = {};

  /**
   * @constructor
   * @param {Object} props
   */
  constructor(props) {
    super(props);
    this.className = "CardContact";
  }

  /**
   * @override
   */
  render() {
    const contact = this.props.currentPage.contacts();
    const organization = this.props.stores.page.organization;
    return (
      <Card
        title="Contact"
        className="full CardContact"
        image={this.props.image}
        {...this.props}
      >
        <h2>PQR BETON</h2>
        <p>
          La Ballastière
          <br />
          {organization.streetAddress}
          <br />
          CH-{organization.postalCode} {organization.addressLocality}
        </p>
        <div className={`${this.className}__contacts`}>
          <div className={`${this.className}__contacts-wrapper`}>
            {contact.map((ctc) => (
              <div key={ctc.ID}>
                <h2>{ctc.ContactType}</h2>
                <p>
                  {ctc.Telephone && (
                    <span>
                      <span style={{ marginRight: "2rem" }}>tél.</span>
                      <a href={`tel:${ctc.Telephone}`}>{ctc.Telephone}</a>
                      <br />
                    </span>
                  )}
                  {ctc.Fax && (
                    <span>
                      <span style={{ marginRight: "2rem" }}>fax</span>
                      <a href={`tel:${ctc.Fax}`}>{ctc.Fax}</a>
                    </span>
                  )}
                </p>
              </div>
            ))}
          </div>
          <div className="Card__link--btn CardContact__link">
            <a href="/contact-form/">
              Nous écrire
              <img src={ChevronRight} alt=">" className="icon" />
            </a>
          </div>
        </div>
      </Card>
    );
  }
}

export default CardContact;



// WEBPACK FOOTER //
// ./src/components/Cards/CardContact.js